import React from 'react';
import { LockIcon } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import { ArtifactIcon } from '../artifact-snippet';
import { artifactTypeLabel } from './artifact-type-label';

/**
 * Shown in the chat artifact panel when an artifact referenced by the chat can't
 * be loaded — effectively always because the chat was shared but this asset was
 * not. (The backend collapses 403/404 into a single error shape; a genuinely
 * deleted artifact is rare here since the chat still references it.)
 */
export const UnsharedArtifactNotice: React.FC<{
  artifactType: string;
  title?: string;
}> = ({ artifactType, title }) => {
  const label = artifactTypeLabel(artifactType);
  const trimmedTitle = title?.trim();
  const heading =
    trimmedTitle !== undefined && trimmedTitle !== ''
      ? `You don't have access to "${trimmedTitle}"`
      : `You don't have access to this ${label}`;

  return (
    <div className="h-full w-full flex items-center justify-center bg-background p-6">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <span className="relative flex size-12 shrink-0 items-center justify-center rounded-full border border-input bg-muted/50 text-muted-foreground">
          <ArtifactIcon artifactType={artifactType} className="size-5" />
          <span className="absolute -bottom-0.5 -right-0.5 flex size-5 items-center justify-center rounded-full border border-background bg-muted text-muted-foreground">
            <LockIcon className="size-3" />
          </span>
        </span>
        <Text.P className="text-sm font-medium text-foreground">
          {heading}
        </Text.P>
        <Text.P className="text-xs text-muted-foreground">
          It hasn't been shared with you — ask whoever shared this chat to share
          the {label} too.
        </Text.P>
      </div>
    </div>
  );
};
